/* eslint-disable react/prop-types */
import React from "react";
import countries from "lib/countries";
import ReactSelect from "react-select";
import Label from "components/ui/Input/Label";
import withAlertModalContext from "./context";
import { dataLayer } from "../../../../lib/analytics";

const COUNTRY_LIMIT = 7;

const TOP_COUNTRIES = ["de", "pt", "us", "gb", "at", "fr", "es", "nl"];

const Countries = ({ context }) => {
  const {
    updateData,
    setError,
    data: { country_codes: selectedCountryCodes },
    errors,
    clearError,
  } = context;
  const allCountries = [...TOP_COUNTRIES, ...Object.keys(countries)];
  const dedupedCountries = [...new Set(allCountries)];

  const translatedCountries = dedupedCountries.map((country) => ({
    label: I18n.t(`country.${country}`),
    value: country,
  }));

  return (
    <div className="b-inquiry-modal__step">
      <Label>{I18n.t("alert_modal.countries.subtitle")}</Label>
      <ReactSelect
        styles={{
          container: (baseStyles, state) => ({
            ...baseStyles,
            borderColor:
              state.isFocused || state.isHover ? "#6acbc9" : "transparent",
          }),
          control: (baseStyles, state) => ({
            ...baseStyles,
            borderColor: state.isFocused || state.isHover ? "#6acbc9" : "black",
            boxShadow:
              state.isFocused || state.isHover ? "0 0 0 1px #6acbc9" : "none",
            "&:hover": {
              borderColor: "#6acbc9",
            },
          }),
          menuList: (baseStyles) => ({
            ...baseStyles,
            maxHeight: "250px",
          }),
          option: (baseStyles, state) => {
            const { isSelected, isFocused } = state;
            const backgroundColor = isSelected
              ? "#2abcbb"
              : isFocused
                ? "#6acbc9"
                : "transparent";
            const color = isSelected || isFocused ? "white" : "black";
            return {
              ...baseStyles,
              backgroundColor,
              color,
              cursor: "pointer",
            };
          },
        }}
        placeholder={I18n.t("alert_modal.countries.placeholder")}
        options={translatedCountries}
        onChange={(selectedOption) => {
          const { value } = selectedOption;
          clearError("country_codes");
          if (selectedCountryCodes.includes(value)) {
            updateData({
              country_codes: selectedCountryCodes.filter((c) => c !== value),
            });
          } else if (selectedCountryCodes.length < COUNTRY_LIMIT) {
            updateData({
              country_codes: [...selectedCountryCodes, value],
            });
          } else {
            setError(
              "country_codes",
              I18n.t("alert_modal.countries.too_many_selected"),
            );
          }
        }}
        value={selectedCountryCodes.map((country) => ({
          name: I18n.t(`country.${country}`),
          value: country,
        }))}
      />
      {errors.country_codes && (
        <div className="b-alerts-modal__error">{errors.country_codes}</div>
      )}
      <div
        className="b-alerts-modal__countries-pill-container"
        style={{ marginTop: errors.country_codes ? "5px" : "25px" }}
      >
        {selectedCountryCodes.map((country) => (
          <div key={country} className="b-alerts-modal__countries-pill">
            {I18n.t(`country.${country}`)}
            <button
              type="button"
              title={I18n.t("generic.remove")}
              className="b-alerts-modal__countries-pill-remove"
              onClick={() => {
                clearError("country_codes");
                updateData({
                  country_codes: selectedCountryCodes.filter(
                    (c) => c !== country,
                  ),
                });
              }}
            >
              &times;
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export const validation = (data) => {
  if (data.country_codes.length === 0) {
    dataLayer.push({
      event: "jobBoardAlertSettingsNextError",
      step: "countries",
    });
    return { country_codes: I18n.t("alert_modal.countries.error") };
  }

  return {};
};

export default withAlertModalContext(Countries);
